import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { Breadcrumbs } from "../../components/Breadcrumbs";

export function TururiPrivateRomania() {
  const { t } = useTranslation();
  const isRo = localStorage.getItem("i18nextLng") === "ro";

  return (
    <>
      {isRo ? (
        <Helmet>
          <link
            rel="canonical"
            href="https://firstgearclub.com/tururi-private-romania"
          />
          <link
            rel="alternate"
            hrefLang="ro"
            href="https://firstgearclub.com/tururi-private-romania"
          />
          <link
            rel="alternate"
            hrefLang="en"
            href="https://firstgearclub.com/tururi-private-romania?lang=en"
          />
          <title>{t("privateTours4x4.metaTitle")}</title>
          <meta
            name="description"
            content={t("privateTours4x4.metaDescription")}
          />
        </Helmet>
      ) : (
        <Helmet>
          <link
            rel="canonical"
            href="https://firstgearclub.com/tururi-private-romania"
          />
          <link
            rel="alternate"
            hrefLang="ro"
            href="https://firstgearclub.com/tururi-private-romania"
          />
          <link
            rel="alternate"
            hrefLang="en"
            href="https://firstgearclub.com/tururi-private-romania?lang=en"
          />
          <title>{t("privateTours4x4.metaTitle")}</title>
          <meta
            name="description"
            content={t("privateTours4x4.metaDescription")}
          />
        </Helmet>
      )}

      <Breadcrumbs
        items={[
          { link: "/tururi-private-romania", name: t("privateTours4x4.h1") }
        ]}
        isH1={true}
        title={t("privateTours4x4.h1")}
      />

      {/* Intro section */}
      <section className="section about-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-img">
                <div className="abt-img">
                  <img
                    src="/assets/img/banner3.jpg"
                    className="img-fluid"
                    alt="Tururi private 4x4 off-road Romania"
                    style={{
                      borderRadius: "8px",
                      width: "100%",
                      objectFit: "cover"
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-content">
                <h6>{t("privateTours4x4.aboveTitle")}</h6>
                <p className="mt-3">{t("privateTours4x4.intro")}</p>
                <p className="mt-3">{t("privateTours4x4.paragraph1")}</p>
                <a
                  href="/contact"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#dd000b",
                    borderColor: "#dd000b",
                    padding: "12px 32px",
                    fontSize: "1rem"
                  }}
                >
                  {t("privateTours4x4.contactButtonLabel")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features section */}
      <section className="section services-section bg-light py-5">
        <div className="container">
          <div className="row g-4">
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm p-4">
                <div className="mb-3">
                  <i
                    className="feather icon-map"
                    style={{ fontSize: "2rem", color: "#dd000b" }}
                  />
                </div>
                <h5 className="primaryFont">
                  {t("privateTours4x4.feature1Title")}
                </h5>
                <p style={{ color: "#555" }}>
                  {t("privateTours4x4.feature1Text")}
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm p-4">
                <div className="mb-3">
                  <i
                    className="feather icon-shield"
                    style={{ fontSize: "2rem", color: "#dd000b" }}
                  />
                </div>
                <h5 className="primaryFont">
                  {t("privateTours4x4.feature2Title")}
                </h5>
                <p style={{ color: "#555" }}>
                  {t("privateTours4x4.feature2Text")}
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm p-4">
                <div className="mb-3">
                  <i
                    className="feather icon-users"
                    style={{ fontSize: "2rem", color: "#dd000b" }}
                  />
                </div>
                <h5 className="primaryFont">
                  {t("privateTours4x4.feature3Title")}
                </h5>
                <p style={{ color: "#555" }}>
                  {t("privateTours4x4.feature3Text")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section py-3">
        <div className="container">
          <div className="row mt-5">
            <div className="col-12">
              <p className="fs-5">{t("privateTours4x4.paragraph2")}</p>
              <div className="mt-4">
                <a
                  href="/contact"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#dd000b",
                    borderColor: "#dd000b",
                    padding: "12px 32px",
                    fontSize: "1rem"
                  }}
                >
                  {t("privateTours4x4.contactButtonLabel")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
